import { useState } from "react";

const useModalAction = () =>{
    const [isModalOpenAction, setModalOpenAction] = useState(false);
    const openModalAction = () => {
      setModalOpenAction(true);
    };
  
    const closeModalAction = () => {
      setModalOpenAction(false);
    };

    return{
        isModalOpenAction,
        closeModalAction,
        setModalOpenAction,
        openModalAction,

    }
}

export default useModalAction;